import { datadogRum } from '@datadog/browser-rum';

import { handleError } from './Error';
import { AppRoutes } from './routes';
import { SocketType, wsEnsureConnected } from './socketHelpers';

import { fmhAPI } from 'api/APIBase';
import { getFmhToken } from 'api/authAPI';
import { setAccessToken } from 'store/auth/authSlice';

export const clearDataForLogout = (clearSessionStorage = true) => {
    if (clearSessionStorage) {
        sessionStorage.clear();
    }
    datadogRum.clearUser();
    window.pendo.clearSession?.(); // Optional chaining to avoid error if pendo is not initialized
};

export const getFMHTokenAndEnsureSocketConnections = async ({
    getAccessTokenSilently,
    logout,
    dispatch,
}) => {
    try {
        const fmhTokenResult = await getFmhToken({
            accessToken: await getAccessTokenSilently(),
        });

        const accessToken = fmhTokenResult.access_token;
        fmhAPI.base = fmhAPI.base.auth(`Bearer ${accessToken}`);

        dispatch(setAccessToken({ accessToken, permissions: fmhTokenResult.permissions }));

        dispatch(wsEnsureConnected({ socketType: SocketType.USER_SUPPORT }));
        dispatch(wsEnsureConnected({ socketType: SocketType.NOTIFICATION }));

        return fmhTokenResult;
    } catch (err) {
        handleError('Error authenticating.', err);
        clearDataForLogout();
        await logout({
            logoutParams: {
                returnTo: `${window.location.origin}${AppRoutes.loggedOut}`,
            },
        });
        return undefined;
    }
};
